export default "__VITE_ASSET__BW5KgZbH__"